import { render, staticRenderFns } from "./CardDadosIniciaisInsumos.vue?vue&type=template&id=76244406&"
import script from "./CardDadosIniciaisInsumos.vue?vue&type=script&lang=js&"
export * from "./CardDadosIniciaisInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports